export const POSITIONING_STATUS = {
  WON: 'won',
  LOST: 'lost',
}